const VerticalDivider = ({ className = "" }: { className?: string }) =>
    <div className={`w-[1px] min-h-[32px] ${className} bg-gray-300`}></div>

export default VerticalDivider